var map = {
	"./Auth/AuthReducers": 1079,
	"./Career/CareerReducers": 6367,
	"./Content/Article/ArticleReducers": 3224,
	"./Content/Branch/BranchReducers": 2001,
	"./Content/Campaign/CampaignReducers": 1440,
	"./Content/Menu/MenuReducers": 1108,
	"./Content/Question/QuestionReducers": 33,
	"./Content/Tag/TagReducers": 583,
	"./Ecommerce/Brand/BrandReducers": 235,
	"./Ecommerce/Category/CategoryReducers": 2442,
	"./Ecommerce/Home/HomeReducers": 2044,
	"./Ecommerce/Order/OrderReducers": 741,
	"./Ecommerce/Product/ProductReducers": 3518,
	"./Feedback/FeedbackReducers": 4889,
	"./Route/RouteReducers": 4336,
	"./Subscription/SubscriptionReducers": 8411,
	"./Vacancy/VacancyReducers": 1361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2986;